module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.1@core-js/library/modules/_redefine.js
// module id = 61
// module chunks = 3